import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataResponse } from '../../../../core/models/data-response';
import { ConfigService } from '../../../../core/services/config/config.service';
import { UtilityService } from '../../../../core/services/utility/utility.service';
import { PatientProblem } from '../../models/patient-problem';

@Injectable({
  providedIn: 'root',
})
export class PatientProblemsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientProblemsEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientProblems`;

  postPatientProblems(
    patientId: number,
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<DataResponse<PatientProblem[]>> {
    const searchParams = {
      pageNumber,
      pageSize,
    };
    return this.utilityService.postRequest<DataResponse<PatientProblem[]>>(
      `${this.patientProblemsEndpoint}?patientId=${patientId}`,
      searchParams,
      { rawResponse: true, applyDefaultTimeout: true }
    );
  }

  getAllPatientProblemsByPatientId(patientId: number): Observable<PatientProblem[]> {
    const url = `${this.patientProblemsEndpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientProblem[]>(url);
  }

  postPrintEvent(patientId: number, ids: number[]): Observable<void> {
    const url = `${this.patientProblemsEndpoint}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, { ids }, { skipGlobalError: true });
  }
}
